import { Icon } from 'copilot-design-system';

import { IconWrapper } from 'src/legacy/components/AgGrid/Renderer/FileCellRendererV2';
import { FilesTableData } from 'src/store/files/types';
import { FileUtils } from 'src/utils';
import { ensureUnreachable } from 'src/utils/common_utils';

type Props = {
  file: FilesTableData;
  EnableFolderLocking: boolean;
};

export const FileIconRenderer = ({ file, EnableFolderLocking }: Props) => {
  switch (file.type) {
    case 'file':
      const extension = file.fileUrl
        ? 'link'
        : (file.fileKey && file.fileKey.split('.').pop()) || '';
      const icon = <IconWrapper extension={extension.toLowerCase()} />;
      return icon || null;
    case 'folder':
      return FileUtils.isReadOnly(file) && EnableFolderLocking ? (
        <Icon icon="FolderLocked" className="h-5 w-5 shrink-0" />
      ) : (
        <Icon icon="Files" className="h-5 w-5 shrink-0" />
      );
    default:
      return ensureUnreachable(file.type);
  }
};
